export const FETCH_TEACHERS = "[Teacher] Fetch Data";
